import { ApiUtility } from "./ApiUtility";

class KalpataruServices {
  kalpataruRoute = "/api/settings/filters?lang=";
  kalpatarudata = "/api/kalyanskalpataru?lang=";
  kalpatarudetailRoute = "/api/KalyansKalpataru/";
  favourite = "/api/kalyanskalpataru/";
  kalpataruDetailRoute = "/api/KalyansKalpataru/";
  categories = "/api/KalyansKalpataru/Categories";

  /** Mobile stores hi/en; Kalpataru APIs expect hindi/english for name fields */
  private getLangParam(): string {
    const lan = localStorage.getItem("lan") || "hindi";
    return lan === "hi" ? "hindi" : lan === "en" ? "english" : lan;
  }

  getFilters(lang: string, productFor: string) {
    const apiLang = lang === "hi" ? "hindi" : lang === "en" ? "english" : lang;
    return ApiUtility.get(
      this.kalpataruRoute + apiLang + "&productFor=" + productFor
    );
  }

  getKalyansKalpataru(
    start: number,
    length: number,
    IsChildLiterature: boolean,
    categoryId: string,
    authorId: string,
    search: string,
    sort: string,
    langId: string,
    isSpecial: boolean
  ) {
    return ApiUtility.get(
      this.kalpatarudata +
      this.getLangParam() +
      "&start=" +
      start +
      "&length=" +
      length +
      "&categoryId=" +
      categoryId +
      "&IsChildLiterature=" +
      IsChildLiterature +
      "&authorId=" +
      authorId +
      "&search=" +
      search +
      "&sort=" +
      sort +
      "&kalyankalpataruLangauge=" +
      langId +
      "&isSpecial=" +
      isSpecial
    );
  }

  getcurrentKalpatarul(id: string, userId?: string) {
    let url =
      this.kalpatarudetailRoute +
      id +
      "?lang=" +
      this.getLangParam();
    if (userId) {
      url += "&UserId=" + userId;
    }
    return ApiUtility.get(url);
  }

  getKalpataruDetail = (id: string) => {
    const lang = this.getLangParam();
    return ApiUtility.get(`${this.kalpatarudetailRoute}${id}/SEO?lang=${lang}`);
  };

  getRelatedKalpatrau(id: string) {
    return ApiUtility.get(
      this.kalpatarudetailRoute +
      id +
      "/related?lang=" +
      this.getLangParam()
    );
  }

  addKalpatruFavourite = (id: string) => {
    return ApiUtility.post(this.favourite + id + "/favourite", {});
  };

  removeKalpatruFavourite = (id: string) => {
    return ApiUtility.delete(this.favourite + id + "/favourite");
  };

  getNavigationDetails = (id: string) => {
    return ApiUtility.post(
      this.kalpatarudetailRoute + "navigation-details", {
        kalyanKalpataruId: id,
      } 
    );    
  };

  getKalPataruById(id: any, userId: any) {
    const url = `${this.kalpataruDetailRoute}${id}?UserId=${userId}`;
    return ApiUtility.get(url);
  }

  getCategories = (lang?: string) => {
    let url = this.categories;
    if (lang) {
      url += `?lang=${lang}`;
    }
    return ApiUtility.get(url);
  };

  GetLanguageDataById(id: string) {
    return ApiUtility.get(
      "/api/languages/" + id + "?lang=" + this.getLangParam()
    );
  }

  GetCategoryDataById(idOrSlug: string) {
    const isMongoId = /^[0-9a-fA-F]{24}$/.test(idOrSlug);
    const identifier = isMongoId ? idOrSlug : `slug-${idOrSlug}`;
    return ApiUtility.get(
      `/api/KalyansKalpataru/Categories/${identifier}?lang=` + this.getLangParam()
    );
  }

  GetAuthorDataById(idOrSlug: string) {
    const isMongoId = /^[0-9a-fA-F]{24}$/.test(idOrSlug);
    const identifier = isMongoId ? idOrSlug : `slug-${idOrSlug}`;
    return ApiUtility.get(
      `/api/KalyansKalpataru/Authors/${identifier}?lang=` + this.getLangParam()
    );
  }
}
export default new KalpataruServices();
